import { useState } from "react";
import { toast } from "sonner";
import { BellRing, Loader2 } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { adminApi, formatApiError } from "@/context/AuthContext";
import { formatShortDate } from "@/lib/api";

// "Envoyer l'alerte": e-mails the subscribers who follow this concert's city
export const EventAlertButton = ({ event }) => {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);

  const open = async () => {
    setLoading(true);
    try {
      setInfo((await adminApi.get(`/admin/events/${event.id}/alert`)).data);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const send = async () => {
    setLoading(true);
    try {
      const { data } = await adminApi.post(`/admin/events/${event.id}/alert`);
      toast.success(`Alerte envoyée à ${data.sent} abonné(s).`);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setLoading(false);
      setInfo(null);
    }
  };

  return (
    <>
      <button onClick={open} disabled={loading} aria-label="Envoyer l'alerte" title="Envoyer l'alerte aux abonnés de la ville" data-testid={`admin-alert-events-${event.id}`}
        className="w-10 h-10 border border-white/20 flex items-center justify-center hover:border-primary hover:text-primary transition-colors">
        {loading && !info ? <Loader2 className="w-4 h-4 animate-spin" /> : <BellRing className="w-4 h-4" />}
      </button>
      <AlertDialog open={!!info} onOpenChange={(o) => !o && setInfo(null)}>
        <AlertDialogContent className="rounded-none bg-black border-white/10" data-testid="admin-alert-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle className="font-display uppercase text-white">Envoyer l'alerte ?</AlertDialogTitle>
            <AlertDialogDescription className="text-zinc-300" data-testid="admin-alert-summary">
              « {event.title} » sera envoyé par e-mail à <strong className="text-white">{info?.count ?? 0} abonné(s)</strong> qui suivent {info?.city || "cette ville"}.
              {info?.sent_at && <><br />Déjà envoyée le {formatShortDate(info.sent_at)} à {info.sent_count} abonné(s).</>}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel className="rounded-none" data-testid="admin-alert-cancel">Annuler</AlertDialogCancel>
            <AlertDialogAction onClick={send} disabled={!info?.count || loading} className="rounded-none bg-primary hover:bg-white hover:text-black" data-testid="admin-alert-confirm">
              {info?.sent_at ? "Renvoyer" : "Envoyer"}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
